import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getSponsoredChallengesForUser, getUserChallenges } from './thunks'

const initialState: UserChallengesState = {
  userChallenges: [],
  userChallengesPaging: null,
  userChallengesStatus: 'idle',
  userChallengesError: null,
  sponsoredChallenges: [],
}

const slice = createSlice({
  name: 'userChallenges',
  initialState,
  reducers: {
    clearUserChallenges: () => {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserChallenges.pending, (state) => {
        state.userChallengesStatus = 'loading'
        state.userChallengesError = null
      })
      .addCase(getUserChallenges.rejected, (state, action) => {
        state.userChallengesStatus = 'failed'
        state.userChallengesError = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getUserChallenges.fulfilled, (state, action) => {
        state.userChallengesStatus = 'succeeded'
        if (action.payload.data) {
          state.userChallenges = action.payload.data
        }
        if (action.payload.paging) {
          state.userChallengesPaging = {
            cursor: action.payload.paging.cursor ?? '',
            pageSize: action.payload.paging.pageSize ?? 0,
            totalCount: action.payload.paging.totalCount ?? 0,
            nextUrl: action.payload.paging.nextUrl ?? null,
            prevUrl: action.payload.paging.prevUrl ?? null,
          }
        }
      })

    builder
      .addCase(getSponsoredChallengesForUser.pending, (state) => {
        state.userChallengesStatus = 'loading'
        state.userChallengesError = null
      })
      .addCase(getSponsoredChallengesForUser.rejected, (state, action) => {
        state.userChallengesStatus = 'failed'
        state.userChallengesError = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getSponsoredChallengesForUser.fulfilled, (state, action) => {
        state.userChallengesStatus = 'succeeded'
        if (action.payload.data) {
          state.sponsoredChallenges = action.payload.data
        }
      })
  },
})

export const selectUserChallenges = (state: RootState): UserChallengesState => state.userChallenges

export default slice.reducer
